import { createAction, props } from '@ngrx/store';
import { INotifyOutstandingRequest } from '../models/notify-outstanding-request.model';
import { INotifyOutstandingResponse } from '../models/notify-outstanding-response.model';

export const notifyAllOutstanding = createAction(
  '[Outstanding] Notify All Outstanding',
  props<{
    request: INotifyOutstandingRequest;
  }>()
);

export const notifyAllOutstandingSuccess = createAction(
  '[Outstanding] Notify All Outstanding Success',
  props<{ response: INotifyOutstandingResponse }>()
);

export const notifyAllOutstandingFailure = createAction(
  '[Outstanding] Notify All Outstanding Failure',
  props<{ error: Error | any }>()
);
